// breadcrumb.service.ts
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface Breadcrumb {
    label: string;
    url: string;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
    private breadcrumbsSubject = new BehaviorSubject<Breadcrumb[]>([]);
    breadcrumbs$ = this.breadcrumbsSubject.asObservable();

    constructor(private router: Router) {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                const root = this.router.routerState.snapshot.root;
                const breadcrumbs = this.buildBreadcrumbs(root);
                this.breadcrumbsSubject.next(breadcrumbs);
            });
    }

    private buildBreadcrumbs(route: ActivatedRouteSnapshot, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
        const label = route.data['breadcrumb'];
        const path = route.routeConfig?.path;

        if (label && path) {
            // Append current route segment to URL
            const segment = route.url.map(segment => segment.path).join('/');
            if (segment) {
                url += `/${segment}`;
            }

            breadcrumbs.push({ label, url }); // temporary URL
        }

        if (route.firstChild) {
            return this.buildBreadcrumbs(route.firstChild, url, breadcrumbs);
        }

        if (breadcrumbs.length) {
            breadcrumbs[breadcrumbs.length - 1].url = '';
        }

        return breadcrumbs;
    }

}
